/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDomainsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetDomainsQuery = {
  __typename?: 'Query';
  domains: Array<{ __typename?: 'Domain'; _id: string; title: string; subTitle?: string | null; timeText?: string | null; color?: string | null; iconUrl?: string | null }>;
};

export type GetUsersDomainsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetUsersDomainsQuery = {
  __typename?: 'Query';
  userDomains: Array<{ __typename?: 'Domain'; _id: string; title: string; subTitle?: string | null; timeText?: string | null; color?: string | null; iconUrl?: string | null }>;
};

export type GetDomainQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;

export type GetDomainQuery = {
  __typename?: 'Query';
  domain: { __typename?: 'Domain'; _id: string; title: string; subTitle?: string | null; timeText?: string | null; color?: string | null; iconUrl?: string | null };
};

export const GetDomainsDocument = gql`
  query GetDomains {
    domains {
      _id
      title
      subTitle
      timeText
      color
      iconUrl
    }
  }
`;

/**
 * __useGetDomainsQuery__
 *
 * To run a query within a React component, call `useGetDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDomainsQuery, GetDomainsQueryVariables>(GetDomainsDocument, options);
}
export function useGetDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDomainsQuery, GetDomainsQueryVariables>(GetDomainsDocument, options);
}
export type GetDomainsQueryHookResult = ReturnType<typeof useGetDomainsQuery>;
export type GetDomainsLazyQueryHookResult = ReturnType<typeof useGetDomainsLazyQuery>;
export type GetDomainsQueryResult = Apollo.QueryResult<GetDomainsQuery, GetDomainsQueryVariables>;
export const GetUsersDomainsDocument = gql`
  query getUsersDomains {
    userDomains {
      _id
      title
      subTitle
      timeText
      color
      iconUrl
    }
  }
`;

/**
 * __useGetUsersDomainsQuery__
 *
 * To run a query within a React component, call `useGetUsersDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersDomainsQuery, GetUsersDomainsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersDomainsQuery, GetUsersDomainsQueryVariables>(GetUsersDomainsDocument, options);
}
export function useGetUsersDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersDomainsQuery, GetUsersDomainsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersDomainsQuery, GetUsersDomainsQueryVariables>(GetUsersDomainsDocument, options);
}
export type GetUsersDomainsQueryHookResult = ReturnType<typeof useGetUsersDomainsQuery>;
export type GetUsersDomainsLazyQueryHookResult = ReturnType<typeof useGetUsersDomainsLazyQuery>;
export type GetUsersDomainsQueryResult = Apollo.QueryResult<GetUsersDomainsQuery, GetUsersDomainsQueryVariables>;
export const GetDomainDocument = gql`
  query GetDomain($id: String!) {
    domain(id: $id) {
      _id
      title
      subTitle
      timeText
      color
      iconUrl
    }
  }
`;

/**
 * __useGetDomainQuery__
 *
 * To run a query within a React component, call `useGetDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDomainQuery(baseOptions: Apollo.QueryHookOptions<GetDomainQuery, GetDomainQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDomainQuery, GetDomainQueryVariables>(GetDomainDocument, options);
}
export function useGetDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainQuery, GetDomainQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDomainQuery, GetDomainQueryVariables>(GetDomainDocument, options);
}
export type GetDomainQueryHookResult = ReturnType<typeof useGetDomainQuery>;
export type GetDomainLazyQueryHookResult = ReturnType<typeof useGetDomainLazyQuery>;
export type GetDomainQueryResult = Apollo.QueryResult<GetDomainQuery, GetDomainQueryVariables>;
